<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="10" align="center" class="mt-4" rounded="xl">
        <v-row class="mx-4 mt-2">
          <v-btn
            fab
            x-small
            class="mx-2 mb-2"
            color="white"
            @click="$router.back()"
          >
            <v-icon light> mdi-arrow-left </v-icon>
          </v-btn>
          <v-col class="pa-0 mt-4">
            <v-btn
              rounded
              color="primary"
              align="left"
              @click="isReliever = !isReliever"
            >
              {{ isReliever ? "Add Attendance" : "Add Reliever" }}
            </v-btn>
          </v-col>
        </v-row>

        <template v-if="!isReliever">
          <v-row class="mx-4 mt-2 my-2">
            <v-col class="pa-0 mt-4">
              <h5 class="text-h6" align="left">Date</h5>
              <v-dialog
                ref="dateDialog"
                v-model="dateMenu"
                :close-on-content-click="false"
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.date"
                    label="Date"
                    readonly
                    solo
                    hide-details
                    dense
                    rounded
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.date"
                  scrollable
                  @input="dateMenu = false"
                ></v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>

          <v-row class="mx-4 mt-2 my-2">
            <v-col class="pa-0">
              <h5 class="text-h6" align="left">Time</h5>
              <v-dialog
                ref="timeDialog"
                v-model="timeMenu"
                :return-value.sync="form.time"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedTime"
                    label="Time"
                    readonly
                    solo
                    hide-details
                    dense
                    rounded
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="timeMenu"
                  v-model="form.time"
                  format="24hr"
                  full-width
                  @click:minute="$refs.timeDialog.save(form.time)"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="timeMenu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.timeDialog.save(form.time)"
                  >
                    OK
                  </v-btn>
                </v-time-picker>
              </v-dialog>
            </v-col>
          </v-row>

          <v-row class="mx-4 mt-2 my-2">
            <v-col class="pa-0">
              <h5 class="text-h6" align="left">Select Client</h5>
              <v-select
                solo
                hide-details
                dense
                rounded
                v-model="form.site_id"
                :items="sites"
                item-text="text"
                item-value="value"
                label="Client"
                @change="getSiteWiseEmployees"
              ></v-select>
            </v-col>
          </v-row>

          <v-row class="mx-4 mt-2 my-2">
            <v-col class="pa-0">
              <h5 class="text-h6" align="left">Employee</h5>
              <v-select
                solo
                hide-details
                dense
                rounded
                v-model="form.user_id"
                :items="employees"
                item-text="text"
                item-value="value"
                label="Employee"
              ></v-select>
            </v-col>
          </v-row>

          <v-row class="mx-4 mt-2 my-2">
            <v-col class="pa-0">
              <h5 class="text-h6" align="left">State</h5>
              <v-select
                solo
                hide-details
                dense
                rounded
                v-model="form.state"
                :items="states"
                item-text="text"
                item-value="value"
                label="State"
              ></v-select>
            </v-col>
          </v-row>

          <v-row class="mx-4 mt-2 my-2">
            <v-col class="pa-0">
              <h5 class="text-h6" align="left">Session Type</h5>
              <v-select
                solo
                hide-details
                dense
                rounded
                v-model="form.session_type_id"
                :items="sessionsTypes"
                item-text="text"
                item-value="value"
                label="Session Type"
              ></v-select>
            </v-col>
          </v-row>

          <v-row class="mx-4 mt-2 my-2">
            <v-col class="pa-0">
              <h5 class="text-h6" align="left">Remark</h5>
              <v-text-field
                solo
                hide-details
                dense
                rounded
                v-model="form.remark"
                placeholder="Remark"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mx-4 mt-2 my-2">
            <v-col class="pa-0">
              <h5 class="text-h6" align="left">Address</h5>
              <v-text-field
                solo
                hide-details
                dense
                rounded
                v-model="form.address"
                placeholder="Address"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mx-4 mt-6 my-2 pb-6">
            <v-col align="center" class="pa-0">
              <v-btn
                min-width="250"
                color="primary"
                rounded
                dark
                :loading="isLoading"
                @click="save"
              >
                Submit
              </v-btn>
            </v-col>
          </v-row>
        </template>

        <template v-if="isReliever">
          <v-row class="mx-4 mt-2 my-2">
            <v-col class="pa-0 mt-4">
              <h5 class="text-h6" align="left">Date</h5>
              <v-dialog
                ref="relieverDateDialog"
                v-model="relieverDateMenu"
                :close-on-content-click="false"
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.date"
                    label="Date"
                    readonly
                    solo
                    hide-details
                    dense
                    rounded
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.date"
                  scrollable
                  @input="relieverDateMenu = false"
                ></v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>

          <v-row class="mx-4 mt-2 my-2">
            <v-col class="pa-0">
              <h5 class="text-h6" align="left">Time</h5>
              <v-dialog
                ref="relieverTimeDialog"
                v-model="relieverTimeMenu"
                :return-value.sync="form.time"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedTime"
                    label="Time"
                    readonly
                    solo
                    hide-details
                    dense
                    rounded
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="relieverTimeMenu"
                  v-model="form.time"
                  format="24hr"
                  full-width
                  @click:minute="$refs.relieverTimeDialog.save(form.time)"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="relieverTimeMenu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.relieverTimeDialog.save(form.time)"
                  >
                    OK
                  </v-btn>
                </v-time-picker>
              </v-dialog>
            </v-col>
          </v-row>

          <v-row class="mx-4 mt-2 my-2">
            <v-col class="pa-0">
              <h5 class="text-h6" align="left">Select Client</h5>
              <v-select
                solo
                hide-details
                dense
                rounded
                v-model="form.site_id"
                :items="sites"
                item-text="text"
                item-value="value"
                label="Client"
                @change="getSiteWiseEmployees"
              ></v-select>
            </v-col>
          </v-row>

          <v-row class="mx-4 mt-2 my-2">
            <v-col class="pa-0">
              <h5 class="text-h6" align="left">Employee</h5>
              <v-select
                solo
                hide-details
                dense
                rounded
                v-model="form.user_id"
                :items="employees"
                item-text="text"
                item-value="value"
                label="Employee"
              ></v-select>
            </v-col>
          </v-row>

          <v-row class="mx-4 mt-2 my-2">
            <v-col class="pa-0">
              <h5 class="text-h6" align="left">Reliever</h5>
              <v-select
                solo
                hide-details
                dense
                rounded
                v-model="form.reliever_id"
                :items="relieverUsers"
                item-text="text"
                item-value="value"
                label="Reliever"
              ></v-select>
            </v-col>
          </v-row>

          <v-row class="mx-4 mt-2 my-2">
            <v-col class="pa-0">
              <h5 class="text-h6" align="left">Description</h5>
              <v-text-field
                solo
                hide-details
                dense
                rounded
                v-model="form.description"
                placeholder="Description"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mx-4 mt-6 my-2 pb-6">
            <v-col align="center" class="pa-0">
              <v-btn
                min-width="250"
                color="primary"
                rounded
                dark
                :loading="isLoading"
                @click="!isReliever ? addReliever() : addReliever()"
              >
                Submit
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-card>
    </v-container>
    <v-container class="footer-text">
      <v-row justify="center">
        <v-col align="center">
          <h3 class="white--text">We Alliance Sparkle</h3>
          <h4 class="white--text">v 1.0.0</h4>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "AttendanceForm",
  data() {
    return {
      form: {
        user_id: "",
        state: "",
        date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        time: moment().format("HH:mm"), // Initialize with current time
        session_type_id: "",
        site_id: "",
        remark: "",
        address: "",
        reliever_id: "",
        description: "",
        source: "PORTAL",
      },
      dateMenu: false,
      timeMenu: false,
      relieverDateMenu: false,
      relieverTimeMenu: false,
      isLoading: false,
      employees: [],
      sessionsTypes: [],
      states: [
        { id: "IN", value: "IN", text: "IN" },
        { id: "OUT", value: "OUT", text: "OUT" },
      ],
      relieverUsers: [],
      isReliever: false,
      sites: [],
    };
  },
  computed: {
    formattedTime: {
      get() {
        return this.form.time
          ? moment(this.form.time, "HH:mm").format("HH:mm")
          : moment().format("HH:mm");
      },
      set(value) {
        this.form.time = moment(value, "HH:mm").format("HH:mm");
      },
    },
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    updateTime(value) {
      this.form.time = moment(value, "HH:mm").format("HH:mm");
      this.timeMenu = false;
    },
    async getMasters() {
      try {
        this.isLoading = true;
        const masters = await axios.get(
          `/monthly_salaries/masters?site_id=${this.site?.id || ""}`
        );

        this.sites = masters.data.sites.map((site) => ({
          id: site.id,
          text: site.name,
          value: site.id,
        }));

        this.relieverUsers = masters.data.relievers.map((user) => ({
          id: user.id,
          text: user.full_name,
          value: user.id,
        }));

        this.sessionsTypes = masters.data.session_types.map((sessionType) => ({
          id: sessionType.id,
          text: sessionType.description,
          value: sessionType.id,
        }));
      } catch (error) {
        console.error("Error fetching masters:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async getSiteWiseEmployees() {
      try {
        this.isLoading = true;
        this.employees = [];
        const response = await axios.get(
          `/users?site_id=${this.form.site_id}&is_active=1`
        );

        this.employees = response.data.data.map((employee) => ({
          id: employee.id,
          text: employee.full_name,
          value: employee.id,
        }));
      } catch (error) {
        console.error("Error fetching employees:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async save() {
      try {
        this.isLoading = true;
        const payload = { ...this.form, source: "PORTAL" };

        if (this.form.date) {
          payload.date = moment(this.form.date, "YYYY-MM-DD").format(
            "YYYY-MM-DD"
          );
        }
        if (this.form.time) {
          payload.time = moment(this.form.time, "HH:mm").format("HH:mm");
        }

        await axios.post(`/users/${this.form.user_id}/user_punches`, payload);
        this.$router.push("/attendances");
      } catch (error) {
        console.error("Error saving attendance:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async addReliever() {
      try {
        this.isLoading = true;
        const payload = {
          user_id: this.form.user_id,
          reliever_id: this.form.reliever_id,
          site_id: this.form.site_id,
          date: this.form.date
            ? moment(this.form.date, "YYYY-MM-DD").format("YYYY-MM-DD")
            : "",
          time: this.form.time
            ? moment(this.form.time, "HH:mm").format("HH:mm")
            : "",
          description: this.form.description,
          source: "PORTAL",
        };

        await axios.post("/user_attendance_relievers", payload);
        this.$router.push("/attendances");
      } catch (error) {
        console.error("Error adding reliever:", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.footer-text {
  position: fixed;
  bottom: 0;
  width: 100%;
}
</style>
